export const MeetingDocs = [
    {
        title: 'January 17, 2020, Regular Meeting',
        timestamp: 'January 17, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_bc5f3e9e9d284933971b0005dc0aa570.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_75e4625c4ac04c4babbfc4c818e202fa.pdf'
            }
        ]
    },
    {
        title: 'February 21, 2020, Regular Meeting',
        timestamp: 'February 21, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_6e47aecb5b4f4fc2a74166015c4445d6.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_5da6dd891f0b45b2af05391dc5886782.pdf'
            }
        ]
    },
    {
        title: 'March 20, 2020, Regular Meeting',
        timestamp: 'March 20, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_c6ca1caf46294add930939b93f255417.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_206310f32e59450cacaf74d8454dffbe.pdf'
            }
        ]
    },
    {
        title: 'April 17, 2020, Regular Meeting',
        timestamp: 'April 17, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_53ce7dd6e08744488081863a967f9fe7.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_65155a3c35544f68a9bd068e7f35fe4b.pdf'
            }
        ]
    },
    {
        title: 'May 17, 2020, Regular Meeting',
        timestamp: 'May 17, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_7527e3ee04284305bb74b41495aadf4f.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_656505db38ec47a8bbe4b19d799cddad.pdf'
            }
        ]
    },
    {
        title: 'June 19, 2020, Regular Meeting',
        timestamp: 'June 19, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_5a5afc6d1a334d4390c135dcc1409a31.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_be1f085848b44274997d0dc30a0b4d34.pdf'
            }
        ]
    },
    {
        title: 'July 17, 2020, Regular Meeting',
        timestamp: 'July 17, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_91dea39211c24d079dec94ad86b5a1a0.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_3128f04d834b48a08c5ac705c28ddd14.pdf'
            }
        ]
    },
    {
        title: 'August 21, 2020, Regular Meeting',
        timestamp: 'August 21, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_712c32309185471798c497a761ab80fc.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_c1c3dfc0e3824990864b524d551df2fc.pdf'
            }
        ]
    },
    {
        title: 'September 18, 2020, Regular Meeting',
        timestamp: 'September 18, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_f79e35077bc34c9694d1c60aca4c0dd7.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_7a8044afcf5e46dba8093d4fd97e319f.docx'
            }
        ]
    },
    {
        title: 'October 16, 2020, Regular Meeting',
        timestamp: 'October 16, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_bf5003b5966b44e9b452ea0f5f6adf83.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_df20b12c7cb846ac91cb738c8c011f48.pdf'
            }
        ]
    },
    {
        title: 'November 20, 2020, Regular Meeting',
        timestamp: 'November 20, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_f0188bb5915d466bbf04680df8ac2ac7.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_5320a83c7dc9436f99916e04ca592e55.pdf'
            }
        ]
    },
    {
        title: 'December 18, 2020, Regular Meeting',
        timestamp: 'December 18, 2020',
        urls: [
            {
                title: 'Minutes',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_c8e571f0b6ee4480b6e1a4a1d6da1824.pdf'
            },
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_379b4838944643439914407329c7562c.pdf'
            }
        ]
    },
    {
        title: 'January 15, 2021, Regular Meeting',
        timestamp: 'January 15, 2021',
        urls: [
            {
                title: 'Agenda',
                url:
                    'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_815205d90c4a420893fa45a39ae58d9b.pdf'
            }
        ]
    },
    {
        title: 'December 19, 2017, Regular Meeting',
        timestamp: 'December 19, 2017',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_22b8a89969f847c29bc7ed38a2e1d7af.pdf'
    },
    {
        title: 'January 8, 2018, Regular Meeting',
        timestamp: 'January 8, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_a9fcccfe3e454f928404076b36a6d3ca.pdf'
    },
    {
        title: 'January 18, 2018, Regular Meeting',
        timestamp: 'January 18, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_d7e83a69a1b944138bee9888b3ae3cf7.pdf'
    },
    {
        title: 'February 9, 2018, Regular Meeting',
        timestamp: 'February 9, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_2e750fd5625e4e448e88afa85e88ed22.pdf'
    },
    {
        title: 'March 9, 2018, Regular Meeting',
        timestamp: 'March 9, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_1e1c274c047848d798a4ad39c06475b7.pdf'
    },
    {
        title: 'March 23, 2018, Regular Meeting',
        timestamp: 'March 23, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_bf096c5a1c7345bba6e973064151b389.pdf'
    },
    {
        title: 'April 13, 2018, Regular Meeting',
        timestamp: 'April 13, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_98a6233e3b47479c8718ebc6c7e070c6.pdf'
    },
    {
        title: 'April 27, 2018, Regular Meeting',
        timestamp: 'April 27, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_178818c146b147d8a56a33b023f8c413.pdf'
    },
    {
        title: 'May 17, 2018, Regular Meeting',
        timestamp: 'May 17, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_e7975f269924497c8f322ecd08dfe555.pdf'
    },
    {
        title: 'June 1, 2018, Regular Meeting',
        timestamp: 'June 1, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_8e3f6ce7535946d6828b64ab97423258.pdf'
    },
    {
        title: 'June 15, 2018, Regular Meeting',
        timestamp: 'June 15, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_6d56c4f967664210995aac45fb820768.pdf'
    },
    {
        title: 'June 29, 2018, Regular Meeting',
        timestamp: 'June 29, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_af64833fc45f4f8583f6abd8b00fd1f8.pdf'
    },
    {
        title: 'July 13, 2018, Regular Meeting',
        timestamp: 'July 13, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_d4652d04acb54d2a8b8b8fdca446eb92.pdf'
    },
    {
        title: 'July 27, 2018, Regular Meeting',
        timestamp: 'July 27, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_002f838e2b754611ac548fdab35c6d78.pdf'
    },
    {
        title: 'August 24, 2018, Regular Meeting',
        timestamp: 'August 24, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_a664e78d9b44495fa3a15c192c8e99b5.pdf'
    },
    {
        title: 'September 7, 2018, Regular Meeting',
        timestamp: 'September 7, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_14913fa784a045c4ada60d52ae4acffe.pdf'
    },
    {
        title: 'October 19, 2018, Regular Meeting',
        timestamp: 'October 19, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_5b378f1ed95840ff8af2d82eaa91c5b6.pdf'
    },
    {
        title: 'November 16, 2018, Regular Meeting',
        timestamp: 'November 16, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_20dafdfaf3d14d1397b30db5b9865a0f.pdf'
    },
    {
        title: 'December 21, 2018, Regular Meeting',
        timestamp: 'December 21, 2018',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_f7bfabe2ec3e4be09873115c2c1fa1a9.pdf'
    },
    {
        title: 'February 8, 2019, Regular Meeting',
        timestamp: 'February 8, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_1e53a8a4ee62472c8d09cb5143fc9e32.pdf'
    },
    {
        title: 'March 15, 2019, Regular Meeting',
        timestamp: 'March 15, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_ce52e4f326a14b6589a6aa88fee1f3dc.pdf'
    },
    {
        title: 'April 18, 2019, Regular Meeting',
        timestamp: 'April 18, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_82e3ba23ff724c3e9bd335e8ec8ccc5d.pdf'
    },
    {
        title: 'May 3, 2019, Regular Meeting',
        timestamp: 'May 3, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_e4aefe68a1234dfb87ad6a17db4b371b.pdf'
    },
    {
        title: 'May 17, 2019, Regular Meeting',
        timestamp: 'May 17, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_50e8ea6d23094dbe95ab796a1c70b604.pdf'
    },
    {
        title: 'May 31, 2019, Regular Meeting',
        timestamp: 'May 31, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_8908fa434978445f980c64476ebc96e2.pdf'
    },
    {
        title: 'June 21, 2019, Regular Meeting',
        timestamp: 'June 21, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_5be078409c0f40a29afdcda44e0bada6.pdf'
    },
    {
        title: 'July 19, 2019, Regular Meeting',
        timestamp: 'July 19, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_7e52da46208449f884e55064ac6031c1.pdf'
    },
    {
        title: 'August 16, 2019, Regular Meeting',
        timestamp: 'August 16, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_beac035a9a994413b79318d62668fe8e.pdf'
    },
    {
        title: 'September 20, 2019, Regular Meeting',
        timestamp: 'September 20, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_ce6f99744714408ab817d5ae0750e8ea.pdf'
    },
    {
        title: 'October 18, 2019, Regular Meeting',
        timestamp: 'October 18, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_0e8c2dd5a59b4183b120c1e6013ef512.pdf'
    },
    {
        title: 'November 1, 2019, Regular Meeting',
        timestamp: 'November 1, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_657989f10ea04a5cbed081ca75d1b519.pdf'
    },
    {
        title: 'November 15, 2019, Regular Meeting',
        timestamp: 'November 15, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_d438231bdc394f75a2d784919d75b3a9.pdf'
    },
    {
        title: 'December 20, 2019, Regular Meeting',
        timestamp: 'December 20, 2019',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/56ecd3_06a62fc11dbc4afa9aad5d919b1d0ab7.pdf'
    }
];
